import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const IncreaseResolutionIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} viewBox="0 0 36 36">
      {/* Rounded square with open top-left and bottom-right */}
      <path
        d="M12 6H9a3 3 0 0 0-3 3v15a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-3"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Diagonal arrow pointing out from near top-right corner */}
      <path
        d="M16 16L27 5"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 2}
        strokeLinecap="round"
      />

      {/* Arrowhead */}
      <path
        d="M20 5h7v7"
        fill="none"
        stroke="currentColor"
        strokeWidth={props.strokeWidth || 2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default IncreaseResolutionIcon;
